// extracted by mini-css-extract-plugin
module.exports = {"white":"_a","gray":"_b","black":"_c"};